import a from "./eq.js";
import s from "./isArrayLike.js";
import f from "./_isIndex.js";
import m from "./isObject.js";
var l = a, n = s, o = f, p = m;
function u(t, e, r) {
  if (!p(r))
    return !1;
  var i = typeof e;
  return (i == "number" ? n(r) && o(e, r.length) : i == "string" && e in r) ? l(r[e], t) : !1;
}
var g = u;
export {
  g as default
};
//# sourceMappingURL=_isIterateeCall.js.map
